import { render, staticRenderFns } from "./BDropdownCustom.vue?vue&type=template&id=d62edc2c&scoped=true"
import script from "./BDropdownCustom.vue?vue&type=script&lang=js"
export * from "./BDropdownCustom.vue?vue&type=script&lang=js"
import style0 from "./BDropdownCustom.vue?vue&type=style&index=0&id=d62edc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62edc2c",
  null
  
)

export default component.exports